import React, { useState } from 'react';
import { gql, useQuery } from '@apollo/client';
import ReactHtmlParser from 'react-html-parser';
import Moment from 'react-moment';
import './News.css';
import NewsletterSubscriptionForm from './NewsletterSubscriptionForm';

const NEWSPOSTS_QUERY = gql`query NewsPostsQuery{
  newsPosts(filters : {is_published: {eq:true}},sort:"published_on:desc"){
    id: documentId,
    title,
    content,
    type,
    createdAt,
    published_on,
    is_published
  }
}
`;

const PAGE_SIZE = 5;

const News = () => {
  const { loading, error, data } = useQuery(NEWSPOSTS_QUERY)
  const [page, setPage] = useState(0)

  if(loading) return ( <h4>...loading</h4>)
  if(error) return <h4>{error.message}</h4>

  const newsPosts = data.newsPosts
  const pageCount = Math.ceil(newsPosts.length / PAGE_SIZE)
  const currentPage = Math.min(page, Math.max(pageCount - 1, 0))
  const start = currentPage * PAGE_SIZE
  const visiblePosts = newsPosts.slice(start, start + PAGE_SIZE)

  return (
    <div id="news" className="small-12 large-12 columns">
      <div className="panel">
        <h4 className="modal-title">News</h4>

        <NewsletterSubscriptionForm />
        {visiblePosts.map(newsPost =>
          <div key={newsPost.id} style={{marginBottom:'1rem'}}>
            <div>
              <div className="news-post-title">{newsPost.title}</div>
              <div className="news-post-subtitle">
                <div className="news-post-type">{newsPost.type}</div> • <Moment format='LLLL' className="news-post-created_at">{newsPost.published_on ? newsPost.published_on : null}</Moment>
                </div>
            </div>
            <div className="news-post-content" dangerouslySetInnerHTML={{ __html: newsPost.content }} />
          </div>
        )}

        {pageCount > 1 && (
          <div className="news-pagination">
            <button
              type="button"
              className="news-pagination-button"
              onClick={() => setPage(currentPage - 1)}
              disabled={currentPage === 0}
            >
              Prev
            </button>
            <span className="news-pagination-status">
              Page {currentPage + 1} of {pageCount}
            </span>
            <button
              type="button"
              className="news-pagination-button"
              onClick={() => setPage(currentPage + 1)}
              disabled={currentPage >= pageCount - 1}
            >
              Next
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

export default News;
